<template>
  <el-dialog v-loading="loading.dialog" class="proEnvTesting_model_dialog" top="5vh" center
    :title="'【' + formInfo.taskInfo.pid + '.' + formInfo.taskInfo.id + '】' + '生产环境测试'" width="90%"
    :before-close="handleClose" :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form ref="form" size="mini" :rules="rules" :model="form">
      <div style="display: flex">
        <el-form-item label="主域名" prop="domain" :label-width="formLabelWidth">
          {{ allSelect.TEXTDOMAINS[form.domain] }}
        </el-form-item>
        <el-form-item label="系统" label-width="65px">
          {{ allSelect.TEXTMODULES[form.module] }}
        </el-form-item>
      </div>
      <div style="display: flex">
        <el-form-item label="产品" :label-width="formLabelWidth">
          {{ allSelect.TEXTUSERS[form.user_pm] }}
        </el-form-item>
        <el-form-item label="开发" label-width="65px">
          {{ allSelect.TEXTUSERS[form.user_rd] }}
        </el-form-item>
        <el-form-item label="测试" label-width="65px">
          {{ allSelect.TEXTUSERS[form.user_qa] }}
        </el-form-item>
        <el-form-item v-if="formInfo.taskInfo.space !== 'operatorSpace'" label="技术评审员" label-width="100px">
          {{ techReviewerCh }}
        </el-form-item>
      </div>
      <el-form-item label="额外部署SQL文件" required :label-width="formLabelWidth">
        <Codemirror style="margin-bottom: 10px" ref="sqlFileditor" readOnly :value='form.sqlExtracontent' @changeTextarea="changeTextarea($event, 'sqlExtracontent')"/>
      </el-form-item>
      <div style="display: flex;">
        <el-form-item label="用例测试结果" required :label-width="formLabelWidth">
          <el-select v-if="formInfo.taskInfo.space !== 'operatorSpace'" v-model="form.test_status">
            <el-option v-for="(key, val) in allSelect.TEXTTESTSTATUS" :key="key" :label="key" :value="val" />
          </el-select>
          <div v-else>{{ allSelect.TEXTTESTSTATUS[form.test_status] }}</div>
        </el-form-item>
        <el-form-item label="测试计划" :label-width="formLabelWidth">
          <MetersphereTestplanBind :taskInfo="{ id: form.id, env: 'production' }" />
        </el-form-item>
      </div>
      <el-form-item label="用例测试结果描述" required :label-width="formLabelWidth">
        <Editor v-if="formInfo.taskInfo.space !== 'operatorSpace'" :disabled="true" :content="form.case_content"
          @contentData="changeContent" dialogVisibleModelType="create" />
        <pre v-if="formInfo.taskInfo.space === 'operatorSpace' && form.case_content" class="case_content_text"
          v-html="form.case_content"></pre>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="formInfo.taskInfo.space !== 'operatorSpace'" type="warning" :loading="loading.proEnvTesting"
        @click="submit">完 成</el-button>
      <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
    <!--  #region dialogVisible 部分 -->
    <el-dialog :close-on-click-modal="false" custom-class="proEnvTesting_model_dialog_child" center title="日志"
      :visible.sync="dialog.proEnvTestingVisible" width="80%" append-to-body left>
      <pre v-if="msg.proEnvTestingMsg" v-html="msg.proEnvTestingMsg" class="tips-message"></pre>
    </el-dialog>
    <!--  #endregion -->
  </el-dialog>
</template>
<script>
import {
  getDevOpsSpaceListStageParmApi,
  postDevopsSpaceStageActionApi,
  getEdiApi
} from "@/server/tops/devOps";
import {
  MetersphereTestplanBind
} from "@/views/tops/devOps/components/model/index.js";
import { Codemirror, Editor } from "@/components";
import { mapState } from "vuex";
export default {
  components: { Codemirror, Editor, MetersphereTestplanBind },
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { };
      },
    },
  },
  data() {
    return {
      form: {
        case_content: '',
        domain: "",
      },
      rules: {
      },
      formLabelWidth: "140px",
      dialog: {
        proEnvTestingVisible: false,
      },
      loading: {
        proEnvTesting: false,
        dialog: true
      },
      msg: {
        proEnvTestingMsg: "",
      },
    };
  },
  async mounted() {
    const {
      user_pm,
      user_qa,
      module = "",
      user_rd,
      id = "",
      pid = "",
      tech_reviewer = "",
      domain = "",
      space = ""
    } = this.formInfo?.taskInfo || {};
    this.form = { ...this.form, id, pid, user_pm, user_qa, module, user_rd, tech_reviewer, domain };
    await this.queryDevOpsSpaceListStageParmInfo();
  },
  computed: {
    ...mapState({
      allSelect: (state) => state.devOps.ALLSELECT,
    }),
    techReviewerCh() {
      let names = '';
      (this.form.tech_reviewer || '').split(",").forEach((item) => {
        if (this.allSelect.TEXTUSERS[item]) {
          names += this.allSelect.TEXTUSERS[item] + ' '
        }
      })
      return names;
    }
  },
  methods: {
    // 获取开发中任务阶段设置信息
    async queryDevOpsSpaceListStageParmInfo() {
      try {
        const { id = "", pid = "" } = this.formInfo?.taskInfo || {};
        const ret = await getDevOpsSpaceListStageParmApi({
          stage_id: "18",// 21
          task_id: id,
          pid,
        });
        if (ret.status === "success") {
          const { common_branch: branch, case_content = '', test_status = '' } = ret.data || {};
          this.form = {
            ...this.form,
            branch,
            case_content,
            test_status,
          };
          await this.querySQLContent();
        } else {
          this.$notify({
            message: ret.error || "数据错误",
            type: "error",
          });
        }
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        });
      } finally {
        this.loading.dialog = false;
      }
    },
    // 获取额外部署sql文件内容
    async querySQLContent() {
      try {
        const { id = "", pid = "" } = this.formInfo?.taskInfo || {};
        const ret = await getEdiApi({ id, pid })
        this.form.sqlExtracontent = ret.data;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        });
      }
    },
    //设置sql语句
    changeTextarea(val, type) {
      this.$set(this.form, type, val);
    },
    // 富文本事件
    changeContent(val) {
      this.form.case_content = val;
    },
    // 关闭弹窗
    handleClose(step = '') {
      if (typeof step == 'string') {
        this.hideDialogVisible(step);
        return
      };
      this.hideDialogVisible();
    },
    // 完成发布
    async submit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loading.proEnvTesting = true;
          this.msg.proEnvTestingMsg = "";
          const {
            id = '',
            pid = '',
            branch = '',
            user_rd = '',
            user_pm = '',
            user_qa = '',
            module = '',
            case_content = '',
            test_status = ''
          } = this.form;
          let param = {
            action: 'run',
            stage_id: 18,
            stage_name: "operator_prodCaseTest",
            task_id: id,
            pid,
            branch,
            user_rd,
            user_pm,
            user_qa,
            module,
            case_content,
            test_status
          };
          try {
            const ret = await postDevopsSpaceStageActionApi(param);
            this.msg.proEnvTestingMsg = JSON.stringify(ret.data || "", null, 2);
            this.dialog.proEnvTestingVisible = true;
            const output = ret?.data?.output || {};
            let info = typeof output === 'string' ? {} : output.case[0];
            if (info.code === 0) {
              setTimeout(() => {
                this.handleClose()
              }, 2000)
            }
          } catch (error) {
            this.msg.proEnvTestingMsg = error || "数据错误";
          } finally {
            this.loading.proEnvTesting = false;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      })
    },
  },
};
</script>
<style lang="scss">
.proEnvTesting_model_dialog {
  .el-dialog__body {
    padding-bottom: 0;
  }

  .el-form-item__label {
    font-weight: bold;
  }

  .case_content_text {
    border: 1px solid #DCDFE6;
    margin: 0;
    border-radius: 3px;
  }

  ;

  .case_content_text>p {
    margin: 0
  }
}

.proEnvTesting_model_dialog_child {
  .el-dialog__body {
    padding: 0 20px 10px;
  }
}

.tips-message {
  max-height: 480px;
  overflow-y: auto;
  white-space: pre-wrap;
  background: #f1fbec;
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.tips-message::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.tips-message::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.tips-message::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}
</style>